module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fm01"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Front Cover:")]), _vm._v(" 2-BIL at West Worthing in 1966. The ‘1’ head code refers to the Brighton-West Worthing service. (Martin James)")]), _vm._v(" "), _c('p', {
    staticClass: "fm02"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Back Cover:")]), _vm._v(" The Southern Electric control room at Woking. (Author)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82665cd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Fm01.vue
// module id = 66
// module chunks = 0